<template>
  <div class="bg-white relative rounded-2xl border grid gap-2 pb-5">
    <Post :class="{ lock: data.is_fake }" :data="data" :lock="lock" />

    <a
      v-if="!lock"
      :href="data.url"
      target="_blank"
      class="button__site bg-white absolute text-sm text-black hover:bg-indigo-500 duration-500 hover:text-white"
    >
      <p>
        Read the case study
      </p>
    </a>
    <a
      v-else
      class="button__site bg-white absolute text-sm text-black hover:bg-indigo-500 duration-500 hover:text-white"
    >
      <router-link to="/pricing">
        <p>
          Unlock this case study
        </p>
      </router-link>
    </a>
  </div>
</template>

<script>
import Post from "./Post";

export default {
  components: { Post },
  props: {
    data: Object,
    isCollection: Boolean,
    unlock: Boolean,
    lock: Boolean,
  },
};
</script>

<style scoped>
.lock {
  filter: blur(12px);
  pointer-events: none;
}
.button__site {
  bottom: -15px;
  position: absolute;
  z-index: 10;
  left: 50%;
  margin-left: -5.8em;
  border-radius: 10px;
  border: 1px solid rgb(90, 103, 216);
  padding: 10px;
}
</style>
